import { Modal as MuiModal } from "@mui/material";
import { IModalProps } from "./Modal.types";
import { formatModalSize } from "./Modal.utils";

export function Modal({
  open,
  size = "md",
  children,
  style,
  ...rest
}: IModalProps) {
  const width = formatModalSize(size);

  return (
    <MuiModal
      open={open}
      style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div
        style={{ width: width, backgroundColor: "white", boxShadow: "24", borderRadius: "16px", padding: "24px" }}
        {...rest}
      >
        {children}
      </div>
    </MuiModal>
  );
}
